//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineEmailContactList",
  props: {
    contactList: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    }
  },
  methods: {
    isLast(idx) {
      return idx === this.contactList.length - 1;
    }
  }
});